var AdaliaForm = {

    submitting: false,
    currentUrl: '',


    init: function(container) {
        container = jQuery(container || 'body');

        container.find('.adalia-form').not('.initialized').each(function() {
            var form = jQuery(this);
            var submit = form.attr('data-submit-button') ? 
                jQuery(form.attr('data-submit-button')) : 
                form.find('button[type="submit"]');

            // Form submit
            submit.off('click', AdaliaForm.handleSubmitClick).on('click', AdaliaForm.handleSubmitClick);

            // Save original state for comparison on exit
            form.attr('data-original-state', form.serialize());
            form.addClass('initialized');
        });

        jQuery(window).off('beforeunload', AdaliaForm.handleExit).on('beforeunload', AdaliaForm.handleExit);
        jQuery(window).off('popstate', AdaliaForm.handleExitViaPopstate).on('popstate', AdaliaForm.handleExitViaPopstate);
        jQuery(document).off('page:before-change turbo:before-visit', AdaliaForm.handleExitViaTurbo).on('page:before-change turbo:before-visit', AdaliaForm.handleExitViaTurbo);

        AdaliaForm.submitting = false;
        AdaliaForm.currentUrl = window.location.href;
    },


    handleExit: function(e) {
        if (AdaliaForm.shouldConfirmExit()) {
            var msg = I18n.t('confirm_exit_without_saving');

            (e || window.event).returnValue = msg; // IE
            return msg;
        }

        return undefined;
    },


    handleExitViaPopstate: function(e) {
        if (AdaliaForm.shouldConfirmExit()) {
            if (confirm(I18n.t('confirm_exit_without_saving'))) {
                jQuery(document).off('page:before-change turbo:before-visit', AdaliaForm.handleExitViaTurbo);
                jQuery(window).off('beforeunload', AdaliaForm.handleExit);
            } else {
                // Stay on the current page.
                history.pushState({}, '', AdaliaForm.currentUrl);
                e.stopImmediatePropagation();
            }
        } else {
            jQuery(document).off('page:before-change turbo:before-visit', AdaliaForm.handleExitViaTurbo);
            jQuery(window).off('beforeunload', AdaliaForm.handleExit);
        }
    },


    handleExitViaTurbo: function(e) {
        if (AdaliaForm.shouldConfirmExit()) {
            if (confirm(I18n.t('confirm_exit_without_saving'))) {
                jQuery(document).off('page:before-change turbo:before-visit', AdaliaForm.handleExitViaTurbo);
                jQuery(window).off('beforeunload', AdaliaForm.handleExit);

                return true;
            }
            return false;
        }
        return true;
    },


    shouldConfirmExit: function () {
        var hasChanges = false;

        jQuery('form.adalia-form').each(function () {
            var form = jQuery(this);

            if (form.attr('data-warn-on-exit') == 'true') {
                hasChanges = (hasChanges || form.attr('data-original-state') != form.serialize() || form.attr('data-state-changed'));
            }
        });

        return hasChanges && !AdaliaForm.submitting;
    },


    handleSubmitClick: function(evt) {
        AdaliaForm.submitting = true;

        var submit = jQuery(this);
        var form = submit.closest('.adalia-form');

        if (form.length == 0) {
            form = submit.closest('.modal-content').find('.adalia-form');
        }

        submit.button('loading');
        AdaliaForm.disableOtherSubmits(submit);

        var insertSubmitValue = function() {
            if (submit.attr('name') && submit.attr('value')) {
                var submitValueInput = form.find('input[name="' + submit.attr('name') + '"]');
                if (submitValueInput.length == 0) {
                    form.append('<input type="hidden" name="' + submit.attr('name') + '" value="' + submit.attr('value') + '" />');
                } else {
                    submitValueInput.val(submit.attr('value'));
                }
            }
        };

        if (submit.attr('data-confirm-template') || form.attr('data-confirm-template')) {
            var confirmContent = jQuery(submit.attr('data-confirm-template') || form.attr('data-confirm-template')).html();
            // if (form.is('.remote')) {
            //     if (form.attr('data-before')) {
            //         eval(form.attr('data-before'));
            //     }
            //
            //     AdaliaForm.customConfirm(confirmContent, function(){
            //         insertSubmitValue();
            //         jQuery.ajax({
            //             url: form.attr('action'),
            //             async: true,
            //             type: 'post',
            //             data: form.serialize() + (form.attr('data-with') || ''),
            //             success: function(data) {
            //                 if (form.attr('data-success')) {
            //                     eval(form.attr('data-success'));
            //                 }
            //                 jQuery(form.attr('data-update')).html(data);
            //                 AdaliaForm.init('body');
            //                 submit.button('reset');
            //                 AdaliaForm.enableOtherSubmits(submit);
            //             }
            //         });
            //     }, function() {
            //         submit.button('reset');
            //         AdaliaForm.enableOtherSubmits(submit);
            //     });
            //
            //     evt.preventDefault();
            // } else {
                AdaliaForm.customConfirm(confirmContent, function(){
                    insertSubmitValue();
                    form.trigger('submit');
                },
                function() {
                    submit.button('reset');
                    AdaliaForm.enableOtherSubmits(submit);
                });
                return false;
            // }
        }
        else {
            var confirmText = (submit.attr('data-confirm-text') || form.attr('data-confirm-text'));

            if (form.is('.remote')) {
                if (form.attr('data-before')) {
                    AdaliaForm.formCallbacks(form.attr('data-before'));
                }

                if (confirmText ? confirm(confirmText) : true) {
                    insertSubmitValue();
                    jQuery.ajax({
                        url: form.attr('action'),
                        async: true,
                        type: 'post',
                        data: form.serialize() + (form.attr('data-with') || ''),
                        success: function(data) {
                            // if (form.attr('data-success')) {
                            //     eval(form.attr('data-success'));
                            // }
                            jQuery(form.attr('data-update')).html(data);
                            AdaliaForm.init('body');
                            submit.button('reset');
                            AdaliaForm.enableOtherSubmits(submit);
                            AdaliaForm.highlightErrors();
                        }
                    });
                } else {
                    submit.button('reset');
                    AdaliaForm.enableOtherSubmits(submit);
                    AdaliaForm.submitting = false;
                }
                evt.preventDefault();
            } else {
                if (confirmText ? confirm(confirmText) : true) {
                    insertSubmitValue();
                    return true;
                } else {
                    submit.button('reset');
                    AdaliaForm.enableOtherSubmits(submit);
                    AdaliaForm.submitting = false;
                    return false;
                }
            }
        }
    },


    disableOtherSubmits: function(submit) {
        var otherSubmits = submit.closest('.adalia-form').find('button[type="submit"]').not(submit);

        otherSubmits.each(function() {
            var s = jQuery(this);
            s.data('original-disabled-state', s.prop('disabled'));
            s.prop('disabled', true);
        });
    },


    enableOtherSubmits: function(submit) {
        var otherSubmits = submit.closest('.adalia-form').find('button[type="submit"]').not(submit);

        otherSubmits.each(function() {
            var s = jQuery(this);
            s.prop('disabled', s.data('original-disabled-state'));
        });
    },


    highlightErrors: function (additionalFormSelector) {
        // additionalFormSelector (optional) Used as additional selector for adalia-form.
        // Used when showing multiple copies of same form (in project reports comment phase)
        var param = '';
        var asWarning = jQuery('.form-errors').is('.alert-warning');

        // Toggle error messages
        jQuery('.toggle-error-details').off('click').on('click', function(e) {
            if (jQuery(this).hasClass('errors-shown')) {
                jQuery(this).closest('.form-errors').find('.draft-error').hide();
                jQuery(this).html(I18n.t('click_here_for_details'));
            } else {
                jQuery(this).closest('.form-errors').find('.draft-error').show();
                jQuery(this).html(I18n.t('hide_details'));
            }
            jQuery(this).toggleClass('errors-shown');
            e.preventDefault();
            return false;
        });

        // Remove form-error from all elements before adding
        jQuery('.form-error').each(function(){
            jQuery('.form-error-message').remove()
            jQuery(this).removeClass('form-error warning')
        })

        // Highlight corresponding input and generate links for error messages
        jQuery('.form-errors li[data-param]').each(function() {
            param = this.getAttribute('data-param');

            var attrMatchSelector = ['[name*="[' + param + ']"]', '[data-name*="[' + param + ']"]'];
            if (this.getAttribute('data-highlight-selector')) { // Add highlight to all
              attrMatchSelector = attrMatchSelector.map(function(selector){
                  return this.getAttribute('data-highlight-selector') + selector;
                }.bind(this));
            }

            attrMatchSelector = attrMatchSelector.join(',').replace(/\[\[dbl-qt\]\]/g, '"');
            var input = jQuery(additionalFormSelector ? '.adalia-form' + additionalFormSelector : '.adalia-form').find('[name="' + param + '"], ' + attrMatchSelector);
            var container = null;

            if (input.closest('.form-component').length > 0) {
                // Special case for forms created with the FormEditor.
                container = input.closest('.form-component');
            } else if (input.is('[type="checkbox"], [type="radio"]')) {
                // These are typically many in a list. Find the common parent.
                container = input.closest('label').parent();
            } else {
                // Closest label or parent.
                container = input.closest('label');
                if (container.length == 0) {
                    container = input.parent();
                }
            }

            if (container.is('.form-error')) {
                // The wrapper was already added for another error
                container = container.parent();
            }
            if (container.find('.form-error').length == 0) {
                container.addClass('form-error' + (asWarning ? ' warning' : ''))
            }

            if (container.is('.input-group') && container.find('.form-error.input-group').length == 0) {
                container.find('.form-error').addClass('input-group');
                //container.removeClass('input-group');
            }
            if(container.find('.form-error-message').length == 0){
                container.append('<div class="form-error-message">' + jQuery(this).text() + '</div>');
            }

            // Link error message to input.
            var link = jQuery('<a href="#" data-target-selector="' + attrMatchSelector.replace(/"/g, '[[dbl-qt]]') + '"></a>');
            jQuery(this).wrapInner(link);
        });

        // Scroll to elements on click to error messages.
        jQuery('.form-errors').on('click', 'a[data-target-selector]', function(e) {
            var target = jQuery(this.getAttribute('data-target-selector').replace(/\[\[dbl-qt\]\]/g, '"'));

            // Cannot scroll to elements that are not rendered since they have no position.
            // In such case scroll to the closest visible parent.
            if (target.is(':hidden')) {
                target = target.closest(':visible').first();
            }

            // Scroll to target
            var scrollParent = (target.scrollParent().offset() ? target.scrollParent() : jQuery('html,body'));
            scrollParent.animate({
                scrollTop: target.offset().top - scrollParent.offset().top - 150
            }, 500);
            // Flash target
            target.closest('.form-error').css({opacity: 0.3}).animate({opacity: 1}, 500);

            e.preventDefault();
            return false;
        });
    },


    customConfirm: function(confirmText, successCallback, cancelCallback) {
        var content = jQuery('<div>');
        content.append(confirmText);

        if (!confirmText) {
            (successCallback || function() {})();
        }
        else {
            openModalDialog({
                title: I18n.t('confirm'),
                modalClass: '',
                hideButtons: false,
                saveLabel: I18n.t('submit'),
                content: content,
                // url: confirmUrl,
                onSubmit: function() { (successCallback || function() {})(); jQuery('#modal-dialog').modal('toggle');},
                onCancel: cancelCallback
            });
        }        
    },


    // Save updated data for comparison on exit
    updateOriginalState: function (form) {
        jQuery(form).attr('data-original-state', jQuery(form).serialize());
        jQuery(form).addClass('initialized');
    },

    formCallbacks: function (key) {
        var callbacks = {
            tinymce_save: function () {
                tinyMCE.activeEditor.save();
            }
        };
        (callbacks[key] || function () {})();
    },
};

window.AdaliaForm = AdaliaForm;